// this file is generated by update_shopify_store_data.py at 2026-01-26 20:20:50.093024
var courses = [];